import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width={256} height={256}><g><g style={{
        stroke: "none",
        strokeWidth: 0,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        strokeMiterlimit: 10,
        fill: "none",
        fillRule: "nonzero",
        opacity: 1
      }}><path d="M170.75 36.974c.53 0 1.052.21 1.44.603l46.253 46.892a2.022 2.022 0 010 2.84l-46.253 46.895a2.023 2.023 0 01-3.463-1.42V87.928C98.123 89.011 41.02 146.496 41.02 217.003a2.022 2.022 0 11-4.046 0c0-73.411 60.012-133.134 133.776-133.134 1.116 0 2.023.904 2.023 2.022v41.963l41.388-41.963-41.388-41.963v20.307a2.022 2.022 0 11-4.046 0V38.997a2.023 2.023 0 012.023-2.023z" style={{
          stroke: "none",
          strokeWidth: 1,
          strokeDasharray: "none",
          strokeLinecap: "butt",
          strokeLinejoin: "miter",
          strokeMiterlimit: 10,
          fill: "#989898",
          fillRule: "nonzero",
          opacity: 1
        }} /></g></g></svg>;
}
export default SvgComponent;